import { Link, useParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { resolveCategory } from "@/lib/news";
import { useSeo } from "@/hooks/useSeo";
import CategoryHeader from "@/pages/category/components/CategoryHeader";
import CategoryList from "@/pages/category/components/CategoryList";

export default function CategoryPage() {
  const { categoryName } = useParams();
  const category = resolveCategory(categoryName || "");

  useSeo({
    title: category
      ? `${category.name}_黑料官网-最新黑料分类`
      : "分类不存在 - 黑料官网",
    description: category
      ? category.description
      : "该分类不存在或已调整，请从黑料官网首页选择分类浏览。",
    keywords: category
      ? `${category.name},黑料官网,${category.name}黑料,最新黑料分类`
      : "黑料官网,黑料信息",
  });

  if (!category) {
    return (
      <SiteLayout>
        <div className="mx-auto flex w-full max-w-[1200px] flex-col items-center justify-center px-4 py-24 text-center md:px-6">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100 text-secondary-500">
            <i className="ri-error-warning-line text-3xl" />
          </span>
          <h1 className="mt-5 font-heading text-xl font-bold text-foreground-950">
            未找到该分类
          </h1>
          <p className="mt-2 text-sm text-foreground-500">
            您访问的分类不存在或已调整，请从首页选择分类。
          </p>
          <Link
            to="/"
            className="mt-6 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </SiteLayout>
    );
  }

  return (
    <SiteLayout>
      <CategoryHeader category={category} />
      <CategoryList key={category.id} category={category} />
    </SiteLayout>
  );
}